export interface ReceiptData {
  recipientName: string;
  amount: number;
  date: string;
  fundName: string;
  churchName: string;
  churchEin: string;
  contributionId: string;
  /** Whether this fund is tax-deductible (defaults to true for backward compat) */
  isTaxDeductible?: boolean;
  /** Fair market value of goods/services received (quid pro quo), if any */
  nonDeductibleAmount?: number;
}

export function generateReceiptEmail(data: ReceiptData): string {
  const isTaxDeductible = data.isTaxDeductible ?? true;
  const nonDeductibleAmount = data.nonDeductibleAmount ?? 0;
  const deductibleAmount = data.amount - nonDeductibleAmount;

  // IRS-required quid-pro-quo disclosure when total exceeds $75
  const quidProQuoDisclosure =
    nonDeductibleAmount > 0
      ? `<p style="font-size: 12px; color: #666;">
          The estimated fair market value of goods or services provided in connection
          with this contribution is $${nonDeductibleAmount.toFixed(2)}. The tax-deductible
          portion of your contribution is $${deductibleAmount.toFixed(2)}.
        </p>`
      : "";

  const taxFooter = isTaxDeductible
    ? `<p style="font-size: 12px; color: #666;">
        ${data.churchName} is a 501(c)(3) tax-exempt organization.<br/>
        Tax ID (EIN): ${data.churchEin}<br/>
        ${nonDeductibleAmount > 0 ? "" : "No goods or services were provided in exchange for this contribution."}
      </p>
      ${quidProQuoDisclosure}`
    : `<p style="font-size: 12px; color: #666;">
        This contribution is not tax-deductible. It was made to a non-deductible fund
        (${data.fundName}) and may not be claimed as a charitable deduction.
      </p>`;

  return `
    <div style="font-family: sans-serif; max-width: 600px; margin: 0 auto;">
      <h1 style="color: #333;">Thank You for Your ${isTaxDeductible ? "Gift" : "Payment"}</h1>

      <p>Dear ${data.recipientName},</p>

      <p>Thank you for your ${isTaxDeductible ? "generous contribution" : "payment"} to ${data.churchName}.</p>

      <div style="background: #f5f5f5; padding: 20px; border-radius: 8px; margin: 20px 0;">
        <p><strong>Amount:</strong> $${data.amount.toFixed(2)}</p>
        <p><strong>Date:</strong> ${data.date}</p>
        <p><strong>Fund:</strong> ${data.fundName}</p>
        <p><strong>Confirmation:</strong> #${data.contributionId.slice(0, 8).toUpperCase()}</p>
      </div>

      ${taxFooter}
    </div>
  `;
}
